/**
 * Decode HTML entities in a string using browser's DOMParser.
 * Safe to use with React as it only extracts text content.
 * 
 * Handles:
 * - Numeric decimal entities: &#8217; -> '
 * - Numeric hex entities: &#x2019; -> '
 * - Named entities: &amp; &lt; &gt; &quot; &apos; &nbsp; etc.
 */
export const decodeHtmlEntities = (text: string | null | undefined): string => {
  if (!text) return '';
  
  // Use DOMParser to decode all HTML entities
  const doc = new DOMParser().parseFromString(text, 'text/html');
  return doc.documentElement.textContent || text;
};
